export const api = "https://gsmarena-three.vercel.app";
